module.exports = __webpack_public_path__ + "img/n8.29284b9b.png";